import React from 'react';
import { Image } from 'expo-image';

interface RemoteIconProps {
  /** Accessibility label; decorative-empty by default. */
  alt?: string;
  size: number;
  testID?: string;
  uri: string;
}

/**
 * Renders a remote icon URL on every platform.
 *
 * Uses expo-image rather than RN's Image because GA-config brand icons
 * (microproduct display_icon_url, external-content icon_url) are
 * predominantly SVGs, and RN's Image silently renders nothing for SVG on
 * native (react-native-web's <img> handles it, which is why it only ever
 * bit on device). expo-image decodes SVG on native and web alike, so a
 * single code path works everywhere — no platform/extension split.
 */
export const RemoteIcon: React.FC<RemoteIconProps> = ({
  alt,
  size,
  testID,
  uri,
}) => (
  <Image
    alt={alt ?? ''}
    contentFit="contain"
    source={{ uri }}
    style={{ height: size, width: size }}
    testID={testID}
  />
);
